import { UseGqlMutationCallbacks } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import { UserHelpRequestInput } from '../../generated.types'
import { UserHelpRequestMutation, useUserHelpRequestMutation } from './userHelpRequest_gen'
export type { UserHelpRequestInput } from '../../generated.types'

type UseUserHelpRequestMutationOptions = UseGqlMutationCallbacks<
  UserHelpRequestMutation,
  UserHelpRequestInput
>
export const useUserHelpRequest = (mutationOptions?: UseUserHelpRequestMutationOptions) => {
  const { mutateAsync: requestHelp } = useUserHelpRequestMutation()
  const mutationOptionsWithNotification = useMutationNotifier({}, mutationOptions)
  return useMutation((input) => requestHelp({ input }), mutationOptionsWithNotification)
}
